import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";

import ApiService from "services/ApiService";
import AuthService from "services/AuthService";
import { ContextOne } from "contexts/ContextOne";
import { dateLocalDisplay } from "lib/Utils";
import Modal from "components/UI/Modal"
import { ToasterContext } from "contexts/ToasterContext";

import AiModelForm from "components/AiModels/AiModelForm"
import withAuth from "withAuth";

import "./AiModels.scss";


const AiModels = () => {
  const { dispatch } = useContext(ContextOne);
  const { AddToast } = useContext(ToasterContext);

  const [aiModels, setAiModels] = useState(null);

  const [showAiModelForm, setShowAiModelForm] = useState(false);

  // Routing

  let navigate = useNavigate();

  const routeToAiModel = (uuid) => {
    let path = `/ai-models/${uuid}`;
    navigate(path);
  }

  // Data Fetching

  const fetchAiModels = async () => {
    const data = await ApiService.getAiModels();
    setAiModels(data);
  };

  const fetchData = async () => {
    dispatch({ type: "loading", val: true });

    await fetchAiModels();

    dispatch({ type: "loading", val: false });
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleAiModelSubmit = async (aiModel) => {
    const data = new FormData();
    data.append("artist", aiModel.artist);
    data.append("description", aiModel.description);
    data.append("pth_file", aiModel.pthFile);
    if (aiModel.indexFile) {
      data.append("index_file", aiModel.indexFile);
    }

    const options = {
      method: "POST",
      body: data
    };

    // const config = {
    //   headers: {
    //     'content-type': 'multipart/form-data',
    //   },
    // };

    dispatch({ type: "loading", val: true });

    AuthService.fetch(
      `${process.env.REACT_APP_API_ENDPOINT}/ai_models/upload`,
      options,
      {}
    )
    .then(
      async (result) => {
        await fetchAiModels();
        AddToast("success", "AI Model Added", null);
        return;
      },
      (error) => {
        AddToast("danger", null, error);
        return;
      }
    )
    .then(() => {
      dispatch({ type: "loading", val: false });
      setShowAiModelForm(false);
    })
  };

  const handleAiModelShowModal = (event) => {
    event.preventDefault();

    setShowAiModelForm(true);
  };

  const handleAiModelCloseModal = (_event) => {
    setShowAiModelForm(false);
  };

  return (
    <>
      <div className="ai-models-component text-center">

        <div className="ai-models-header">
          <div className="title">
            <h1>Models</h1>
          </div>
        </div>

        <table className="table tbl-striped table-sm">
          <thead>
            <tr>
              <th>Artist</th>
              <th>Description</th>
              <th>Model Name</th>
              <th>Created Date</th>
              <th>
                <div className="icon-button" onClick={handleAiModelShowModal}>
                  <FontAwesomeIcon
                    icon={faPlusCircle}
                  />
                </div>
              </th>
            </tr>
          </thead>

          <tbody>
            {
              aiModels &&
              aiModels.map(a =>
                <tr key={a.uuid} onClick={() => routeToAiModel(a.uuid)}>
                  <td>{a.artist}</td>
                  <td>{a.description}</td>
                  <td>{a.model_name}</td>
                  <td>{dateLocalDisplay(a.created_at)}</td>
                  <td></td>
                </tr>
              )
            }
          </tbody>
        </table>
      </div>

      <Modal show={showAiModelForm} modalClosed={handleAiModelCloseModal} >
        <h4 className="text-center">Add AI Model</h4>
        <hr/>

        { showAiModelForm &&
          <AiModelForm
            cancelForm={handleAiModelCloseModal}
            handleSubmit={handleAiModelSubmit}
          />
        }
      </Modal>
    </>
  );
};

export default withAuth(AiModels);
